var dist = {};

export { dist as __exports };
//# sourceMappingURL=index2.js.map
